<template>
  <model-form
    :model="bookingWeek"
    max-content-width="100%"
    lockable
    :title="'Booking Week of ' + bookingWeek.date.i18n('date') + `, ${currentSite.name}.`"
    :custom-save-function="bookingWeek.saveBookingWeek"
  >
    <q-tabs
      v-model="tab"
      align="justify"
    >
      <q-tab
        name="plan-elements"
        label="1. Plan Elements"
      />
      <q-tab
        name="title-selection"
        label="2. Title Selection"
      />
      <q-tab
        name="plan-layout"
        label="3. Plan Layout"
      />
      <q-tab
        name="schedule"
        label="4. Schedule"
      />
    </q-tabs>
    <q-tab-panels
      v-model="tab"
      keep-alive
    >
      <q-tab-panel
        name="plan-elements"
      >
        <q-card-section>
          <booking-week-detail
            :booking-week="bookingWeek"
          />
        </q-card-section>
      </q-tab-panel>
      <q-tab-panel
        name="title-selection"
      >
        <q-card-section>
          <title-plan-list
            :booking-week="bookingWeek"
          />
        </q-card-section>
      </q-tab-panel>

      <q-tab-panel
        name="plan-layout"
      >
        <q-card-section>
          <combined-layout
            ref="combinedLayout"
            :booking-week="bookingWeek"
            :schedule="bookingWeek.finalSiteSchedule"
            @preview-layout="value => previewLayout = value"
            @previewing-action="value => previewingAction = value"
          />
        </q-card-section>
      </q-tab-panel>

      <q-tab-panel
        name="schedule"
      >
        <q-card-section>
          <schedule
            v-show="!bookingWeek.batchSavingInProgress"
            :booking-week="bookingWeek"
            :preview-layout="previewLayout"
            :previewing-action="previewingAction"
          />
        </q-card-section>
      </q-tab-panel>
    </q-tab-panels>
  </model-form>
</template>

<script>

import { date } from 'quasar'
import BookingWeekDetail from 'src/modules/admin/booking-week/components/BookingWeekDetail'
import CombinedLayout from 'src/modules/admin/booking-week/components/CombinedLayout'
import TitlePlanList from 'src/modules/admin/booking-week/components/TitlePlanList'
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'
import Schedule from 'src/modules/admin/schedule/Schedule'

export default {
  name: 'BookingWeekForm',
  components: {
    ModelForm,
    BookingWeekDetail,
    CombinedLayout,
    TitlePlanList,
    Schedule
  },
  data () {
    return {
      previewLayout: {},
      previewingAction: false,

      tab: 'schedule',

      date
    }
  },
  configuration: ['currentSite'],
  models: {
    bookingWeek: {
      watchQuery: false,
      planElements: {
        bookingWeekMovies: {
          movie: {
            showingBadges: 'default',
            marathonMovies: 'default'
          }
        },
        parentPlanElement: {
          id: true
        },
        showingBadges: 'default'
      },
      site: {
        screens: 'default',
        timeSlots: 'default',
        priceCards: 'default'
      },
      defaultSiteSchedule: 'default',
      showings: {
        movie: {
          showingBadges: 'default'
        },
        movieTerm: {
          showingBadges: 'default'
        },
        bookingWeekMovie: {
          movie: 'default',
          planElement: {
            showingBadges: 'default'
          }
        },
        screen: {
          showingBadges: 'default'
        },
        additionalShowingBadges: 'default',
        customShowingBadges: 'default',
        customSeatChart: 'default',
        predictedAttendance: true,
        showings: {
          movie: {
            showingBadges: 'default'
          },
          movieTerm: {
            showingBadges: 'default'
          },
          screen: {
            showingBadges: 'default'
          },
          additionalShowingBadges: 'default',
          customShowingBadges: 'default',
          customSeatChart: 'default',
          predictedAttendance: true
        }
      }
    }
  },
  methods: {
    beforeShow () {
      this.bookingWeek.actualScheduleInitialized = false
      this.bookingWeek.computedLayoutInitialized = false
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
